import React from "react";
import * as actions from './Actions';
import Service from '../../service/Service';
const service = new Service();

export default function BabySizeCompSection ({sizeCompData, eleRef}){
    // var eleRef = babynamesData.eleRef;
    // var babynamesData = babynamesData.babynamesData;
    return(
        <section className="babysize-section">
            <div className="section-title">Baby Size Comparison</div>
            <div className="baby-size-wrapper">
                {sizeCompData.babysize && sizeCompData.babysize.map((sizedata, id) =>
                <div key={id} className="baby-size-block">
                    <div className="babyWeek">{sizedata.pregnancy_week}</div>
                    <div className="len-wt"><span className="len-wt-text">Length - {sizedata.average_length}</span> <span className="R11_9e"> (Crown to Rump)</span>
                        <span className="len-wt-text right">Weight - {sizedata.average_weight}</span>
                    </div>
                    <div className="baby-comparison">
                         <div className="sizeComp-outer left" id="fruit-img">
                            <div className="baby-size-images">
                                <div className="comparison-img">
                                    <img src={sizedata.fruit_url.replace("http://", "https://")} id="dev_fruit_img"></img>
                                </div>
                                <div className="img-name">{sizedata.fruit_name}</div>
                            </div>
                        </div>
                        <div className="sizeComp-outer left" id="animal-img">
                            <div className="baby-size-images">
                                <div className="comparison-img">
                                    <img src={sizedata.animal_url.replace("http://", "https://")} id="dev_animal_img"></img>
                                </div>
                                <div className="img-name">{sizedata.animal_name}</div>
                            </div>
                        </div>
                        <div className="sizeComp-outer left" id="sweet-img">
                            <div className="baby-size-images">
                                <div className="comparison-img">
                                    <img src={sizedata.sweets_url.replace("http://", "https://")} id="dev_sweet_img"></img>
                                </div>
                                <div className="img-name">{sizedata.sweets_name}</div>
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            {global.ftk ?
            <a href="https://parenting.firstcry.com/tools/baby-size-comparison/" className="moreResults dev_v_all" title="Baby Size Comparison">SEE MORE RESULTS</a>
            :
            <div className="moreResults dev_v_all" title="Baby Size Comparison" onClick={()=>actions.nonLoggedin()}>SEE MORE RESULTS</div>
            }
        </section>
    );
}
